import { useSnackbarContext } from 'Context/SnackbarContext';
import { QueryVal } from 'Helpers/Query';
import React from 'react';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';

const MAGIC_LINK_TOKEN_PARAM = 'magicLinkToken';

export const useMagicLink = (setAuthCollection) => {
  const [loading, setLoading] = React.useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const { homeResource } = useHomeContext();
  const magicLinkToken = QueryVal(MAGIC_LINK_TOKEN_PARAM);

  const submitAuthToken = async (rel, token) => {
    try {
      setLoading(true);
      // This is bad because it manipulates a relationship, but this will save a round trip and reduce the api surface area around authentication
      const resp = await rel.link('related').copy().equal(MAGIC_LINK_TOKEN_PARAM, token).post({}, { deprecatedAllowAlterOfRelation: true });

      setAuthCollection(resp);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    const relationship = homeResource?.withRelationship(fr.relationships.authMagicLink.name, (rel) => rel, () => null);

    if (relationship && magicLinkToken) {
      submitAuthToken(relationship, magicLinkToken);
    }
  }, []); // Only run this once on mount, do not add dependencies

  return { loading };
};
